import React, { Fragment } from 'react';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
// import Timer from '../Timer';
import { sendLogKafka, Events } from '~/web-frontend-components/helpers/kafka';
const useStyles = createUseStyles({
    leftPadding: { paddingLeft: '5px' },
    leftAlign: { textAlign: 'left' },
    inherit: { color: 'inherit' },
    flexGrow: { flexGrow: 1 },
    gray: { color: '#999', },
    red: { color: 'red', },
    flex: { display: 'flex' }
}, { name: 'Description' });
export const Description = (props) => {
    if (!props.description) {
        return null;
    }
    const classes = useStyles();
    return <Fragment>
      <div className={`${classes.leftPadding} ${classes.gray}`}>
         {props.displayGamesNumber && props.description.num !== 0 &&
            <div style={{ color: 'rgba(0, 0, 0, 0.7)', fontWeight: '500' }} className="g-n">
               {`#${props.description.num || ''}`}
            </div>}
         {props.description.time}
      </div>
      <div className={`${classes.leftPadding} ${classes.flexGrow} ${classes.leftAlign}`}>
         {/* {props.description?.sScore?.sScoreData?.sd ?
           <div className={classes.flex}>
              <b className={classes.red}> {props.description?.sScore?.sScoreData?.sd} </b >
              <Timer t={props.description.sScore.sScoreData.t} deltaTimeMs={props.deltaTimeMs} />
           </div>
           : ''} */}
         <p>
            <Link to={props.url} className={classes.inherit} title={`${props.description.team1} ${props.description.team2 && ` - ${props.description.team2}`}`} onClick={() => sendLogKafka(Events.eventViewed, { eventId: props.matchId, sourceScreen: 'live' })}>
               <span> {props.description.team1}</span>
               {props.inline ? ' - ' : <br />}
               <span> {props.description.team2}</span>
            </Link>
         </p>
         {/* {!props.description?.sScore?.sScoreData?.sd ?
           <b className={classes.red}> {props.description.score} </b >
           : ''} */}
         <b className={classes.red}> {props.description.score} </b>

      </div>
   </Fragment>;
};



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes/Description.jsx